// extracted by mini-css-extract-plugin
module.exports = {"container":"RemoveExpirationActionButtons_container__1A3VD","buttons":"RemoveExpirationActionButtons_buttons__QeR4D"};